import React from 'react';

const SIZES = {
  sm: { img: 28, font: 12 },
  md: { img: 48, font: 14 },
  lg: { img: 80, font: 22 },
};

const Logo = ({ size = 'md', showName = true }) => {
  const { img, font } = SIZES[size] || SIZES.md;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: size === 'sm' ? 4 : 6 }}>
      <img src="/logo512.png" alt="Nodecharm" style={{ width: img, height: img, opacity: 0.8 }} />
      {showName && <span style={{ fontSize: font, fontWeight: 600, color: '#999', letterSpacing: '0.5px' }}>Nodecharm</span>}
    </div>
  );
};

export default Logo;
